import {State, Action, Selector, StateContext} from '@ngxs/store';
import {
  GetMakes,
  GetModelsData, GetUpdatedAt
} from './vehicle.actions';
import {VehicleService} from '@shared/service/vehicle/vehicle.service';
import {IVehicleMake, IVehicleModel} from '@shared/interfaces';
import {Injectable} from '@angular/core';

export interface VehicleStateModel {
  makes: IVehicleMake[];
  models: { [k: string]: IVehicleModel[] };
  updatedAt: string | number;
}

@State<VehicleStateModel>({
  name: 'vehicle',
  defaults: {
    makes: [],
    models: {},
    updatedAt: null
  }
})
@Injectable()
export class VehicleState {
  constructor(private vehicleService: VehicleService) {
  }

  @Selector()
  static getMakes(state: VehicleStateModel) {
    return state.makes;
  }

  @Selector()
  static getModels(state: VehicleStateModel) {
    return state.models;
  }

  @Selector()
  static getUpdatedAt(state: VehicleStateModel) {
    return state.updatedAt;
  }

  @Action(GetMakes)
  getMakesData({getState, patchState}: StateContext<VehicleStateModel>) {
    // We want to get all the makes only once
    const curMakes = getState().makes;
    if (curMakes && curMakes.length > 0) {
      return Promise.resolve(true);
    }
    return this.vehicleService.getMakes()
      .then((result) => {
        patchState({
          makes: result
        });
      });
  }

  @Action(GetModelsData)
  getModelsData({getState, patchState}: StateContext<VehicleStateModel>, {payload}: GetModelsData) {
    // We want to get all the makes only once
    let models = getState().models;
    const make = payload.make;
    const curModelsByMake = models[make];
    if (curModelsByMake && curModelsByMake.length > 0) {
      return Promise.resolve(true);
    }
    return this.vehicleService.getModelsByMake(make)
      .then((result) => {
        models = Object.assign({}, models, {[make]: result});
        return patchState({
          models
        });
      });
  }

  @Action(GetUpdatedAt)
  getUpdatedAt({patchState}: StateContext<VehicleStateModel>) {
    // We want to get all the makes only once
    return this.vehicleService.getUpdatedAt()
      .then((result) => {
        patchState({
          updatedAt: result
        });
      });
  }
}
